// tslint:disable
/**
 * Robotic Platform Pattern Generation API
 * WebSocket API contract for generating palletization strategy templates and layer layouts.  This module is exposed through the Robotic Platform WebSocket dispatcher (not a standalone REST API). The OpenAPI path below documents the JSON request/response message payload for the `generatePatternPlan` handler.  Transport notes: - Connect to the WebSocket server and send a JSON object with top-level `type: generatePatternPlan` - Receive one JSON response frame for the request (success or handler-level error) - Validation and internal handler errors are encoded in the JSON response body with `status: error` - No module-level authentication or rate limiting is implemented in this repository 
 *
 * The version of the OpenAPI document: 1.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { StackPlan } from './stack-plan';

/**
 * 
 * @export
 * @interface GeneratePlanOkResponse
 */
export interface GeneratePlanOkResponse {
    /**
     * 
     * @type {string}
     * @memberof GeneratePlanOkResponse
     */
    status: GeneratePlanOkResponseStatusEnum;
    /**
     * 
     * @type {StackPlan}
     * @memberof GeneratePlanOkResponse
     */
    plan: StackPlan;
}

/**
    * @export
    * @enum {string}
    */
export enum GeneratePlanOkResponseStatusEnum {
    OK = 'ok'
}



